import moment from "moment";

export var EXTRATO_FILTERS_KEY = "financeiro.extrato";

// Defaults depend on "today", so they are built at mount (usePersistedFilters).
export var getDefaultExtratoFilters = function() {
    return {
        month: moment().format("YYYY-MM"),
        customRange: null, // { from: 'YYYY-MM-DD', to: 'YYYY-MM-DD' } when a custom period is chosen
        bankId: null,
        type: "all",
        search: "",
    };
};

// Turns the saved filter into the /extrato query params.
export var getExtratoRequest = function(filters) {
    var bankId = filters.bankId || null;
    if (filters.customRange && filters.customRange.from && filters.customRange.to) {
        return { from: filters.customRange.from, to: filters.customRange.to, bank_account_id: bankId };
    }
    var month = moment(filters.month, "YYYY-MM");
    return {
        from: month.clone().startOf("month").format("YYYY-MM-DD"),
        to: month.clone().endOf("month").format("YYYY-MM-DD"),
        bank_account_id: bankId,
    };
};

export var isExtratoPeriodDefault = function(filters, defaults) {
    return !filters.customRange && filters.month === defaults.month;
};

export var getExtratoPeriodLabel = function(filters) {
    if (filters.customRange) {
        return moment(filters.customRange.from).format("DD/MM/YY") + " - " + moment(filters.customRange.to).format("DD/MM/YY");
    }
    return "Mes: " + moment(filters.month, "YYYY-MM").format("MMM/YYYY");
};

// Badge: only what differs from the defaults.
export var countActiveExtratoFilters = function(filters, defaults) {
    return (isExtratoPeriodDefault(filters, defaults) ? 0 : 1) +
        (filters.bankId ? 1 : 0) +
        (filters.type !== "all" ? 1 : 0) +
        (filters.search ? 1 : 0);
};

export var filterExtratoRows = function(data, type, search) {
    var result = data || [];
    if (type === "credit") result = result.filter(function(r) { return r.type === "credit"; });
    else if (type === "debit") result = result.filter(function(r) { return r.type === "debit"; });
    if (search) {
        var s = search.toLowerCase();
        result = result.filter(function(r) {
            return (r.description && r.description.toLowerCase().indexOf(s) > -1) ||
                   (r.category && r.category.toLowerCase().indexOf(s) > -1) ||
                   (r.customer && r.customer.name && r.customer.name.toLowerCase().indexOf(s) > -1);
        });
    }
    return result;
};
